/**
 * WorkFlow Reducers
 */
import {
    WORKFLOW_ACTION,
    ADD_ACADEMYADMIN,
    ASSIGN_ACADEMYADMIN,
    ASSIGN_COACH_STUDENT,
    ALL_ASSIGNED_STUDENT,
    ASSIGN_PROGRAM_INCLUSION,
    DELETE_ASSIGN_COACH,
    DELETE_COACH_STUDENT,
    GET_PARTICULAR_ACADEMY_PROGRAM,
    ASSIGN_PROGRAM_FOR_STUDENT,
} from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    loading: false,
    assignedstudents: []
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case WORKFLOW_ACTION:
            return { ...state, loading: true };

        case ADD_ACADEMYADMIN:
            return { ...state, loading: false };

        case ASSIGN_ACADEMYADMIN:
            return { ...state, loading: false };

        case ASSIGN_COACH_STUDENT:
            return { ...state, loading: false };

        case ALL_ASSIGNED_STUDENT:
            return { ...state, loading: false, assignedstudents: action.payload };

        case ASSIGN_PROGRAM_INCLUSION:
            return { ...state, loading: false };

        case DELETE_ASSIGN_COACH:
            return { ...state, loading: false };

        case DELETE_COACH_STUDENT:
            return { ...state, loading: false };

        case GET_PARTICULAR_ACADEMY_PROGRAM:
            return { ...state, loading: false, assignedstudents: action.payload };

        case ASSIGN_PROGRAM_FOR_STUDENT:
            return { ...state, loading: false };

        default: return { ...state };
    }
}